import { AnimatePresence, motion, easeInOut } from "framer-motion";
import React from "react";
import { Link } from "react-router-dom";
import { isSwapRouteEnabled } from "utils/helper";

const MobileMenu = ({ mobMenu, handleClose }) => {
  return (
    <div className="mobOnly">
      <AnimatePresence>
        {mobMenu && (
          <motion.div
            initial={{ x: "-100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "-100%", opacity: 0 }}
            transition={{ duration: 0.35, ease: easeInOut }}
            className="mobileMenu"
          >
            <ul className="menuList mb-0">
              <li onClick={handleClose}>
                <Link
                  to={"/"}
                  exact
                  activeclassname="active"
                  className="nav-link"
                >
                  Home
                </Link>
              </li>
              <li onClick={handleClose}>
                <a
                  href={process.env.REACT_APP_STAKING_URL}
                  target="_self"
                  rel="noreferrer"
                  className="nav-link"
                >
                  Prestake
                  <span className="nav-tag">Closed</span>
                </a>
              </li>
              <li onClick={handleClose}>
                <Link
                  to={"/swap"}
                  exact
                  onClick={(e) => {
                    !isSwapRouteEnabled && e.preventDefault();
                  }}
                  activeclassname="active"
                  className={`nav-link ${
                    !isSwapRouteEnabled ? "disabled" : ""
                  }`}
                >
                  Swap
                </Link>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MobileMenu;
